import _ from 'underscore';
import Promise from 'bluebird';
import { getLocalStorage } from '@bingads-webui/storage';

import {
  getImportRecommendationService,
  getLogger,
  getImportRecommendationStorage,
  getImportRecommendationApi,
} from './import-recommendation-service/index';
import { settings } from './constants';

export const getDefaultImportRecommendationService = ({
  odata, userId, userName, logger,
}) => {
  if (userId && logger) {
    const api = getImportRecommendationApi({ odata, userId, logger });
    const localStorage = getLocalStorage(logger);
    const storage = getImportRecommendationStorage({ storageApi: localStorage, userName: userName || `${userId}` });
    const service = getImportRecommendationService({
      api, storage, settings, logger,
    });
    return service;
  }
  return null;
};

const OPPORTUNITY_TYPE = 'importcalloutcard';

export const gotoPageByClickingRecommendation = (scope, siteMap, page, recommendationId) => {
  const pageItem = _.findWhere(siteMap, { id: page });
  const { routePrefix, route } = pageItem;
  const params = {
    ...scope.values,
    opportunityId: recommendationId,
    opportunityType: OPPORTUNITY_TYPE,
  };
  const search = _.reduce(params, (result, value, key) => `${result}&${key}=${value}`, '');
  if (!_.isEmpty(pageItem)) {
    // from smart campaign page, need to refresh whole page.
    if (route && route.indexOf(routePrefix) >= 0 && route.indexOf('http') >= 0) {
      window.location.href = `${route}?${search}`;
    } else {
      const { history } = scope;
      history.replace({
        pathname: `${routePrefix}${route}`,
        search: `?${search}`,
      });
    }
  }
};

export const adoptResumeScheduleRecommendation = ({
  odata, serverContext, scope, loggerApi, status, schedules,
}) => {
  if (serverContext && serverContext.CurrentUser && scope && scope.values) {
    const { opportunityId, opportunityType } = scope.values;
    if (_.isNumber(opportunityId) && opportunityType === OPPORTUNITY_TYPE) {
      // only support google import currently
      const googleImportSchedules = _.filter(schedules, s => s.ImportType === 'GoogleAPIImport');
      if (googleImportSchedules && googleImportSchedules.length > 0) {
        const idList = _.reduce(googleImportSchedules, (prev, { Id }) => `${Id},${prev}`, '');
        const logger = getLogger(loggerApi);
        if (status === 'Active') {
          const { Id: userId, Name: userName } = serverContext.CurrentUser;
          const service = getDefaultImportRecommendationService({
            odata, userId, userName, logger,
          });
          logger.logTrace(`[ImportCalloutCard] Adopted resume schedule recommendation, RID:${opportunityId}, schedules:${idList}`);
          return service.adoptRecommendation({ id: opportunityId });
        }
        logger.logTrace(`[ImportCalloutCard] Didn't adopted resume schedule recommendation, ids:${idList}, RID:${opportunityId}, status:${status}`);
      }
    }
  }
  return Promise.resolve(null);
};

export const adoptResumeImportRecommendation = ({
  odata, serverContext, scope, loggerApi, info,
}) => {
  if (serverContext && serverContext.CurrentUser && scope && scope.values) {
    const logger = getLogger(loggerApi);
    const { opportunityId, opportunityType } = scope.values;

    const { Name } = info || {};
    if (_.isNumber(opportunityId) && opportunityType === OPPORTUNITY_TYPE) {
      const { Id: userId, Name: userName } = serverContext.CurrentUser;
      const service = getDefaultImportRecommendationService({
        odata, userId, userName, logger,
      });
      logger.logTrace(`[ImportCalloutCard] Adopted resume google import recommendation, import_name:${Name}, RID:${opportunityId}`);
      return service.adoptRecommendation({ id: opportunityId });
    }
    logger.logTrace(`[ImportCalloutCard] Didn't adopted resume google import recommendation, import_name:${Name}, RID:${opportunityId}`);
  }
  return Promise.resolve(null);
};
